import { render, staticRenderFns } from "./table-pageable.vue?vue&type=template&id=51f0a7ea&"
import script from "./table-pageable.component.ts?vue&type=script&lang=ts&"
export * from "./table-pageable.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports